import { render, staticRenderFns } from "./NewView.vue?vue&type=template&id=e423ef88"
import script from "@/views/modules/ReviewerDocuments/js/NewView.js?vue&type=script&lang=js&external"
export * from "@/views/modules/ReviewerDocuments/js/NewView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports